<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.mpsVersion"
                selectType="select"
                requestApi="/scp/scpMpsPlans/listMpsPlanVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.listCategory"
                selectType="selectMultiple"
                :selectData="productBroadCategoryOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="内外部">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.listSide"
                selectType="selectMultiple"
                :selectData="listSideOpinions"
                :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :dropdown-match-select-width="false"
                :value.sync="queryParams.listSupplier"
                selectType="selectMultipleSearch"
                requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
                @successCallBack="handleSupplierListSuccess"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
                searchParam="supplierName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单类型">
              <global-select
                show-search
                :value.sync="queryParams.listOrderType"
                selectType="selectMultiple"
                :selectData="orderTypeValOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <!-- 物料编码 -->
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.itemId"
                :dropdown-match-select-width="false"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMpsPlans/listItemCodeCp"
                :assembleLabel="true"
                :selectItem="{ value: 'realValue', label: 'selectedValue', thirdLabel: 'bringOutDataOne' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>
          <!-- 项目组 -->
          <a-col :md="6" :sm="24">
            <a-form-item label="项目组">
              <global-select
                :value.sync="queryParams.projectTeamList"
                selectType="selectMultipleSearch"
                requestApi="/system/lookup/data/likeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_PROJECT_TEAM' }"
                searchParam="lookupValue"
                :dropdown-match-select-width="false"
              />
            </a-form-item>
          </a-col>
          <!-- 物料名称 -->
          <a-col :md="6" :sm="24">
            <a-form-item label="物料名称">
              <a-input v-model="queryParams.itemName"></a-input>
              <!-- <global-select
                :value.sync="queryParams.itemName"
                :dropdown-match-select-width="false"
                selectType="selectSearch"
                requestApi="/scp/scpMpsPlans/getItemName"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                searchParam="name" /> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="">
              <div class="search-form-check-box-area">
                <a-checkbox :checked="queryParams.stop === 'N'" @change="handleIsStopChange">非停产物料</a-checkbox>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="ApiExportScpMpsPlans" ref="download" />
      <a-button @click="queryParams.mpsVersion?$refs.createModal.show(queryParams.mpsVersion):$message.error('请选择版本')" type="primary">新建</a-button>
      <a-button @click="handleExport" type="primary" >导出</a-button>
      <a-button v-hasPermi="['scp:scpSopMpsSupplierDetails:remove']" @click="handleDelAll" type="danger">全部删除</a-button>
      <a-button @click="handImport">导入计划单</a-button>
      <a-button @click="importTemplate">导入计划单模版</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :scroll="{ fixScreen: true, x: 1300 }"
          @change="handleTableChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MPS_SUPPLY_DETAILS_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="(!isEdit || currentId !== text.record.id) && text.record.orderType === 'PLANORDER'" @click="handleEdit(text.record)">编辑</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
                <a class="ml10" v-if="text.record.orderType === 'PLANORDER'" @click="handleDel(text.record)">删除</a>
              </span>
              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ meaning(text.record, item.dataIndex) }}</span>
                <template v-if="isEdit && currentId === text.record.id">
                  <lsSelectPage
                    v-if="item.dataIndex === 'supplierName'"
                    :datas="setArray(item.dataList)"
                    placeholder="请选择"
                    searchKey="label"
                    valueKey="selectedValue"
                    :value.sync="item.dataValueIndex ? text.record[item.dataValueIndex] : text.record[item.dataIndex]"
                    @change="(val, arr) => selectChange(val, arr, item.dataIndex, text.record)"
                  >
                    <template slot="select-option" slot-scope="{items}">
                      <a-select-option v-for="i in items" :key="i.selectedValue" :value="i.selectedValue" :title="i.label">
                        {{ i.label }}
                      </a-select-option>
                    </template>
                  </lsSelectPage>
                  <!--                  <global-select
                    v-if="item.dataIndex === 'supplierName'"
                    :value.sync="item.dataValueIndex ? text.record[item.dataValueIndex] : text.record[item.dataIndex]"
                    selectType="selectSearch"
                    :requestApi="item.requestApi"
                    :selectData="setArray(item.dataList)"
                    :selectItem="{ value: item.value, label: item.label }"
                    :setParams="{ itemId: text.record.itemId }"
                    :searchParam="item.searchParam ? item.searchParam : ''"
                    :allowClear="false"
                    size="small"
                    :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                    @change="(val, arr) => selectChange(val, arr, item.dataIndex, text.record)"
                    :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
                  />-->
                  <global-select
                    v-else
                    :value.sync="item.dataValueIndex ? text.record[item.dataValueIndex] : text.record[item.dataIndex]"
                    :selectType="item.selectType ? item.selectType : 'select'"
                    :requestApi="item.requestApi"
                    :selectData="setArray(item.dataList)"
                    :selectItem="{ value: item.value, label: item.label }"
                    :setParams="item.setParams ? setParamsHandle(text.record, item.dataIndex) : null"
                    :searchParam="item.searchParam ? item.searchParam : ''"
                    :allowClear="false"
                    size="small"
                    :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                    @change="(val, arr) => selectChange(val, arr, item.dataIndex, text.record)"
                    :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
                  />
                </template>
              </span>
              <span v-else-if="item.type === 'date'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.text && $moment(text.text).format('YYYY-MM-DD') }}</span>
                <a-date-picker v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" valueFormat="YYYY-MM-DD" size="small" />
              </span>
              <span v-else-if="item.type === 'dateTime'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-date-picker v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" show-time valueFormat="YYYY-MM-DD HH:mm:ss" size="small" />
              </span>
              <span v-else-if="item.type === 'input'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else-if="item.dataIndex === 'amount'">{{ text.text && formatNum(text.text, 3) }}</span>
              <span v-else>{{ text.text }}</span>
            </div>
          </template>
        </ls-api-table>
        <StartWeeklyBalancing @handle-success="handleOk" ref="startWeeklyBalancing"></StartWeeklyBalancing>
        <!-- <create-form
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        /> -->
        <create-form
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        />
        <import-data
          ref="importData"
          :url="url"
          :sopDfcBasicDataId="queryParams.mpsVersion"
          @handle-success="handleOk"
        />
      </div>
    </template>

  </ls-table-layout>
</template>

          <script>
      import { generateLsTableResData } from '@/utils/util.js'
      import deepClone from "lodash.clonedeep";
       import { ApiSendSopMonthPlan } from '@/api/scp/month-plan/month-plan.js'
       import moment from 'moment';
       import { ApiStopScpMpsPlans, ApiExportScpMpsPlans } from '@/api/mps/basic-data/mps-option.js'
       import { apiFindPageSupplierDetail, apiDeleteSupplierDetail, apiListSupplierCode, apiEditSupplierDetail, apiBatchDeleteSupplierDetail } from '@/api/mps/basic-data/mps-supply-details.js'
       import StartWeeklyBalancing from './components/StartWeeklyBalancing';
       import CreateForm from './components/CreateForm'
       import ImportData from './components/ImportData'
       import DownloadModal from '@/views/components/download-modal/download-modal.vue'
       import { formatNum } from '@/utils/fomatteNum'
      export default {
        // eslint-disable-next-line
        name: 'Mps-supply-details',
        components: {
          StartWeeklyBalancing,
          CreateForm,
          ImportData,
          DownloadModal
        },
        computed: {
        // 其他计算属性
        // ...
        formattedParams () {
          return {
            monthStart: moment(this.currentPeriod).format("YYYYMM")
            // monthEnd: moment(this.baseInfo.forecastPeriodTo).format("YYYYMM")
          };
        }
      },
        data () {
          return {
            timer: null,
            sorterParams: {},
            formatNum,
            ApiExportScpMpsPlans,
            url: '/scp/scpMpsPlans/importSupplierDetail',
            listSideOpinions: [],
            productBroadCategoryOpinions: [],
            moment: moment, // 在 data 中创建 moment 实例
            currentPeriod: '',
            isEdit: false,
            currentId: "",
            lookUpCode: '',
            // 表格多选
            selectedRowKeys: [],
            selectedRows: [],
            // 表格配置
            tableProps: {
              requestApi: generateLsTableResData(apiFindPageSupplierDetail, true),
              pageCurrent: true
            },
            // 查询参数
            queryParams: {
                mpsVersion: undefined,
                listCategory: undefined,
                listSide: undefined,
                listSupplier: undefined,
                listOrderType: undefined,
                itemId: undefined,
                stop: undefined
            },
            baseUomFlagOptions: [
              {
                dictLabel: '是',
                dictValue: 'Y'
              },
              {
                dictLabel: '否',
                dictValue: 'N'
              }
            ],
            // 表格字段
            columns: [
              {
                title: '物料编码',
                dataIndex: 'itemCode',
                scopedSlots: { customRender: 'itemCode' },
                ellipsis: true,
                width: 150,
                align: 'center'
              },
              {
                title: '工艺大类',
                dataIndex: 'category',
                ellipsis: true,
                align: 'center',
                width: 180
              },
              {
                title: '物料名称',
                width: 120,
                dataIndex: 'itemName',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '一件代发',
                width: 90,
                ellipsis: true,
                dataIndex: 'isRetailFlag',
                align: 'left'
              },
              {
                title: '规格描述',
                width: 220,
                ellipsis: true,
                dataIndex: 'specification',
                align: 'left'
              },
              {
                title: '供应商',
                width: 200,
                dataIndex: 'supplierName',
                dataValueIndex: 'supplierId',
                scopedSlots: { customRender: 'supplierName' },
                ellipsis: true,
                align: 'center',
                type: "select",
                setParams: true,
                dataList: 'listSupplierListCode',
                value: 'selectedValue',
                label: 'label',
                searchParams: 'label',
                requestApi: '/scp/scpMpsPlans/listSupplierCode'
              },
              {
                title: '内外部',
                width: 100,
                dataIndex: 'supplierClass',
                scopedSlots: { customRender: 'supplierClass' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '订单类型',
                width: 180,
                dataIndex: 'orderTypeVal',
                scopedSlots: { customRender: 'orderTypeVal' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '单据编号',
                width: 180,
                dataIndex: 'orderNumber',
                scopedSlots: { customRender: 'orderNumber' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '完成日期',
                width: 180,
                dataIndex: 'newDuckDate',
                sorter: true,
                // sortDirections: ['ascend', 'descend'],
                scopedSlots: { customRender: 'newDuckDate' },
                ellipsis: true,
                align: 'center',
                type: "date"
              },
              {
                title: '数量',
                width: 180,
                dataIndex: 'quantity',
                scopedSlots: { customRender: 'quantity' },
                ellipsis: true,
                align: 'center',
                type: "inputNumber"
              },
              {
                title: '平均采购价',
                width: 180,
                dataIndex: 'averagePurchasePrice',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '金额',
                width: 120,
                dataIndex: 'amount',
                scopedSlots: { customRender: 'amount' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '操作',
                width: 150,
                stickyFixed: 'right',
                align: 'center',
                dataIndex: 'operation',
                scopedSlots: { customRender: 'operation' }
              }
            ],
            listSupplierListName: [],
            listSupplierListCode: [],
            orderTypeValOpinions: [],
            uomClassOptions: []
          }
        },
        created () {
          this.queryParams.mpsVersion = this.$route.query.id
          // this.getLastSalesForecast()
          //  this.getLookUpCode('SOP_PROCESS_STATU')
          this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryOpinions')
          this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'listSideOpinions')
          this.getLookupList('SCP_MRP_SUPPLY_TYPE', 'orderTypeValOpinions')
          // this.getFindList('')
        },
        mounted () {
          if (this.queryParams.mpsVersion) {
            this.onSearch()
          }
        },
        methods: {
          handleVersionChange (val, list) {
            if (val) {
              const filteredObject = list.filter(obj => obj.realValue === val);
              this.queryParams.sopDfcBasicDataId = filteredObject[0].selectedValue
              this.queryParams.versionCode = filteredObject[0].label
              this.queryParams.description = filteredObject[0].realValue
              this.sopDfcBasicDataId = this.queryParams.sopDfcBasicDataId;
              this.versionCode = this.queryParams.versionCode;
              this.description = this.queryParams.description;
            }
          },
          selectChange (val, arr, index, record) {
            if (index === "supplierName") {
              record.supplierId = val
            }
          },
          setParamsHandle (record, dataIndex) {
          },
          setArray (arr) {
            return this[arr]
          },
          meaning (record, dataIndex) {
            return record[dataIndex]
          },
          getSupplierList (itemId) {
            apiListSupplierCode({ supplierName: '', itemId: itemId }).then(res => {
              this.listSupplierListCode = res
            })
          },
          handImport () {
            if (this.queryParams.mpsVersion) {
              this.$refs.importData.show(this.queryParams.mpsVersion)
            } else {
              this.$message.error('版本不能为空')
            }
          },
              /** 下载模板操作 */
          importTemplate () {
            this.download('scp/scpMpsPlans/exportSupplierDetailTemplate', {
              ...this.queryParams
            }, `供应明细模板.xlsx`)
          },
        // 导入导出excel
          /** 导出按钮操作 */
          handleExport () {
            if (!this.queryParams.mpsVersion) {
              this.$message.error('请输入版本')
              return
            }
            const params = deepClone(this.queryParams)
            if (params.listSupplier && params.listSupplier.findIndex(item => item === '未分配供应商的行') !== -1) {
              params.listSupplier.splice(params.listSupplier.findIndex(item => item === '未分配供应商的行'), 1)
              params.empty = '1'
            }
            this.$refs.download.openModal(params)
            // this.download('scp/scpMpsPlans/exportSupplierDetail', {
            //   ...this.queryParams
            // }, `供应明细界面_${new Date().getTime()}.xlsx`)
          },
        getLookupList (type, arr) {
            const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
            }
            this.getLookupListData(lookupQueryParams).then(response => {
            this[arr] = response.rows
            if (type === 'MDM_ORG_SUPPLIER_CLASS' || type === 'SCP_MRP_SUPPLY_TYPE') {
                const filteredArray = response.rows.filter(function (obj) {
                    return obj.attribute2 === "Y";
                    });
                    this[arr] = filteredArray
            }
            })
        },
              // 新增/修改框事件
        handleOk () {
          this.onSearch()
        },
          handleStopCalculationAlert () {
                  /** 检查只能选择一个 */
              if (this.selectedRows.length > 1) {
                    this.$message.error('停止计算选择项不能大于1')
                    return
                  }
                  if (this.selectedRows.length === 0) {
                    this.$message.error('请勾选其中一项')
                    return
                  }
                  const self = this
                  this.$confirm({
                    title: '提示',
                    content: '你确定停止该记录吗？',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk () {
                      self.handleStopCalculation()
                    },
                    onCancel () {
                    }
                  });
          },
          handleStopCalculation () {
            ApiStopScpMpsPlans(this.selectedRowKeys[0]).then(response => {
              if (response.code === 200) {
                this.$message.success('停止成功')
              } else {
                this.$message.error(response.msg)
              }
            })
          },
            getLookUpCode (code) {
                const lookupQueryParams = {
                    lookupType: code,
                    current: 1,
                    pageSize: 100
                }
                this.getLookupListData(lookupQueryParams).then().then(response => {
                // this.lookUpCode[code] = response.rows
                this.$set(this.lookUpCode, code, response.rows)
                })
            },
          resetQuery () {
            this.queryParams = {
                mpsVersion: this.queryParams.mpsVersion || undefined,
                listCategory: undefined,
                listSide: undefined,
                listSupplier: undefined,
                listOrderType: undefined,
                itemId: undefined,
                stop: undefined
            }
            this.onSearch()
          },
          handleGoCapacityLoad () {
            /** 检查只能选择一个 */
            if (this.selectedRows.length > 1) {
              this.$message.error('产能负荷的选择项不能大于1')
              return
            }
            if (this.selectedRows.length === 0) {
              this.$message.error('请勾选其中一项')
              return
            }
            this.$router.push({ path: `/monthly-plan/capacityLoadPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
          },
          handleGoDemand () {
                    /** 检查只能选择一个 */
                    if (this.selectedRows.length > 1) {
              this.$message.error('生产需求的选择项不能大于1')
              return
            }
            if (this.selectedRows.length === 0) {
              this.$message.error('请勾选其中一项')
              return
            }
            this.$router.push({ path: `/monthly-plan/productionDemandPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
          },
          handleDel (record) {
            const self = this
            this.$confirm({
              title: '提示',
              content: '你确定删除该记录吗？',
              okText: '确定',
              okType: 'danger',
              cancelText: '取消',
              onOk () {
                self.deleteShipmentForecast(record)
              },
              onCancel () {
              }
            });
          },
          handleGoStatus (record) {
            this.$router.push({ path: `/shipmentForecastManagement/runningStatus/${record.id}` })
          },
          deleteShipmentForecast (record) {
            apiDeleteSupplierDetail(record.id).then((response) => {
              if (response.code === 200) {
                this.$message.success('删除成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
          },
          sendShipmentForecast (record) {
            ApiSendSopMonthPlan({ id: record.id }).then((response) => {
              if (response.code === 200) {
                this.$message.success('发布成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
          },
          handleGoDetail (record) {
            this.$router.push({ path: `/mps-work-desk/detail/${record.id}` })
          },
          handleEdit (record) {
            if (this.currentId && record.id !== this.currentId && this.isEdit) {
                  this.$message.warning('请保存上次编辑的数据')
                  return;
                }
                this.isEdit = true;
                record.supplierId = record.sourceSupplierId ? record.sourceSupplierId.toString() : ''
                this.getSupplierList(record.itemId)
                this.currentId = record.id;
          },
          handleAdd () {
            this.$router.push({ path: `/monthly-plan/editPage/` })
          },
          /** 行选中 */
          selectedRowChange (selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
          },
          // 表单搜索
          onSearch (isNotGoFirstPage) {
            if (!this.queryParams.mpsVersion) {
              this.$message.error('请输入版本')
              return
            }
            const params = deepClone(this.queryParams)
            if (params.listSupplier && params.listSupplier.findIndex(item => item === '未分配供应商的行') !== -1) {
              params.listSupplier.splice(params.listSupplier.findIndex(item => item === '未分配供应商的行'), 1)
              params.empty = '1'
            }
            this.isEdit = false
            this.$refs.dataTable.searchParams = { ...params, ...this.sorterParams }
            this.$refs.dataTable.getData(isNotGoFirstPage)
          },
          // 编辑-保存
          handleSave (record) {
            if (!record.supplierId && record.sourceSupplierId) {
              record.supplierId = record.sourceSupplierId
            }
            apiEditSupplierDetail(record).then(response => {
              if (response.code === 200) {
                this.$message.success('保存成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
          },
          // 取消
          handleCancel (record) {
            this.isEdit = false
            this.onSearch()
          },
          statusOnChange (record) {
            record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
          },
          handleSupplierListSuccess (selectList) {
            selectList.unshift({
              label: "未分配供应商的行",
              realValue: "EMPTY",
              selectedValue: "未分配供应商的行"
            })
          },
          handleDelAll () {
            if (this.$refs.dataTable.myDataSource.length === 0) {
              this.$message.warning('表格中没有数据')
              return
            }
            this.$confirm({
              title: '警告',
              content: `真的要删除${this.$refs.dataTable.myPagination.total}条数据项吗?`,
              okText: '删除',
              okType: 'danger',
              cancelText: '取消',
              onOk: () => {
                apiBatchDeleteSupplierDetail(this.$refs.dataTable.searchParams).then(response => {
                  if (response.code === 200) {
                    this.$message.success('删除成功!')
                    this.onSearch()
                  } else {
                    this.$message.error(response.msg)
                  }
                })
              }
            })
          },
          handleIsStopChange (e) {
            if (e.target.checked) {
              this.queryParams.stop = 'N'
            } else {
              this.queryParams.stop = undefined
            }
          },
          // table排序等
          handleTableChange (pagination, filters, sorter, { currentDataSource }) {
            const obj = {}
            if (sorter.columnKey === "newDuckDate") {
              if(sorter.order === undefined) {
                obj.duckDateOrder = {}
              } else {
                obj.duckDateOrder = sorter.order === "ascend" ? 0 : 1
              }
            }
            this.sorterParams = obj
            if (this.timer) {
              return
            }
            this.timer = setTimeout(() => {
              this.timer = null
              this.onSearch(true)
            }, 100)
          }
        }
      }
      </script>

     <style scoped lang="less">
      .ml10 {
        margin-left: 10px;
      }
      .page-header-content {
        /deep/.ant-select{
          width: 140px;
        }
        /deep/.ant-calendar-picker{
          min-width: 150px !important;
        }
      }
      /deep/.ant-calendar-picker{
        width: 100% !important
      }
      /deep/.ant-form-item-control-wrapper{
        width: 25% !important
      }
      .search-form-check-box-area {
        padding-left: 20px;
      }
      /deep/.ant-drawer-content-wrapper{
        .ant-form-item{
          .ant-form-item-control-wrapper{
            width: 83.33% !important
          }
        }
      }
      </style>
